import { render, staticRenderFns } from "./ModalVerDetalleAlta.vue?vue&type=template&id=fa14a046&"
import script from "./ModalVerDetalleAlta.vue?vue&type=script&lang=ts&"
export * from "./ModalVerDetalleAlta.vue?vue&type=script&lang=ts&"
import style0 from "./ModalVerDetalleAlta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('fa14a046', component.options)
    } else {
      api.reload('fa14a046', component.options)
    }
    module.hot.accept("./ModalVerDetalleAlta.vue?vue&type=template&id=fa14a046&", function () {
      api.rerender('fa14a046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/AltasServicio/ModalVerDetalleAlta.vue"
export default component.exports